var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8356",
    "data-name": "Rectangle 8356",
    width: 41,
    height: 30,
    rx: 3,
    transform: "translate(0 -0.026)",
    fill: "#dfeafb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Placeholder_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Placeholder_",
    "data-name": "Placeholder ",
    clipPath: "url(#clip-Placeholder_)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8355",
    "data-name": "Rectangle 8355",
    width: 41,
    height: 30,
    rx: 3,
    transform: "translate(3 9)",
    fill: "#dfeafb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23",
    "data-name": "Mask Group 23",
    transform: "translate(3 10.026)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19964",
    "data-name": "Path 19964",
    d: "M1520.336,392.031l10.387-9.91s.9-.81,1.333-.823,1.358.919,1.358.919l17.705,17.27h-30.783Z",
    transform: "translate(-1505.088 -367.131)",
    fill: "#4975ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19963",
    "data-name": "Path 19963",
    d: "M1520.336,392.031l10.387-9.91s.9-.81,1.333-.823,1.358.919,1.358.919l17.705,17.27h-30.783Z",
    transform: "translate(-1520.479 -369.513)",
    fill: "#6093f2"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_436",
    "data-name": "Ellipse 436",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(10 13)",
    fill: "#6093f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/Placeholder.beaed4f42221a00e307a4f185ec79eda.svg";
export { ForwardRef as ReactComponent };